import styled from 'styled-components';
import theme from 'styled-theming';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';
var avatarSize = theme('size', {
  small: rem(12),
  medium: rem(16),
  large: rem(24),
  xlarge: rem(32),
  xxlarge: rem(40)
});
export var StyledAvatarContainer = styled.div.withConfig({
  displayName: "Avatarstyles__StyledAvatarContainer",
  componentId: "sc-1yhru5w-0"
})(["display:inline-flex;align-items:center;height:", ";"], avatarSize);
export var StyledAvatar = styled.div.withConfig({
  displayName: "Avatarstyles__StyledAvatar",
  componentId: "sc-1yhru5w-1"
})(["&.", "-avatar--border{border:1px solid var(--dentsu-color-n250);}width:", ";height:", ";border-radius:50%;color:var(--dentsu-color-black);display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;position:relative;background-color:var(--dentsu-color-n150);font-size:calc(", " / 2.5);"], prefix, avatarSize, avatarSize, avatarSize);
export var StyledAvatarName = styled.div.attrs({
  className: "".concat(prefix, "-avatar__name")
}).withConfig({
  displayName: "Avatarstyles__StyledAvatarName",
  componentId: "sc-1yhru5w-2"
})(["text-align:center;text-transform:uppercase;font-weight:600;line-height:1;"]);
export var StyledAvatarImage = styled.img.attrs({
  className: "".concat(prefix, "-avatar__image")
}).withConfig({
  displayName: "Avatarstyles__StyledAvatarImage",
  componentId: "sc-1yhru5w-3"
})(["object-fit:cover;border-radius:50%;width:100%;height:100%;"]);
export var StyledAvatarChildren = styled.span.withConfig({
  displayName: "Avatarstyles__StyledAvatarChildren",
  componentId: "sc-1yhru5w-4"
})(["display:inline-block;margin-left:4px;line-height:1;color:var(--dentsu-color-black);white-space:nowrap;font-size:var(--dentsu-font-size-12);"]);